import { AbacoWebModule, ApplicationReadyEvent } from "@abaco/web-common/src/app";
import AmbientalWidgetsAPI from './api/AmbientalWidgetAPI';
import globals from "./globals";
import { HTTPClient } from "@abaco/web-common/src/HTTP";
import DashboardChartsModule from "@abaco/dashboard-module/src/modules/charts/index";
import SSOModule from '@abaco/sso-web-module/src/abaco-module';
import FarmerRegistryModule from "@abaco/farm-registry/src/modules/farm-registry";
import GlobalStateModule from "@abaco/portal-global-state/src/modules/global-state";

export const MODULE_ID = "ambiental_widgets_module";

export default class AmbientalWidgetsModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    readonly id = MODULE_ID;
    readonly globalComponents = globals;

    private ambApi!: AmbientalWidgetsAPI;
    private apiCreated!: boolean;
    private ssoModule!: SSOModule;

    dependsOn = {
        [FarmerRegistryModule.MODULE_ID]: () => new FarmerRegistryModule(),
        [GlobalStateModule.MODULE_ID]: () => new GlobalStateModule(),
        [DashboardChartsModule.MODULE_ID]: () => new DashboardChartsModule(),
    }

    async onApplicationReady(evt: ApplicationReadyEvent) {
        this.ssoModule = evt.modules.find((m) => m.id === SSOModule.MODULE_ID) as SSOModule;
    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if (this.apiCreated) {
            return;
        }
        this.apiCreated = true;

        const AmbientalWidgetsAPI = (await import("./api/AmbientalWidgetAPI")).default;
        this.ambApi = new AmbientalWidgetsAPI(http);
    }

    public get ambientalApi() {
        return this.ambApi;
    }
}
